import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { utils } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import bowser from 'yola-bowser';

const { Box, HorizontalStack, Paragraph, InfoWithPopover, ColorCircle } = designSystem;

const isTouchDevice = bowser.mobile || bowser.tablet;

function ColorPanel({ title, color, opacity = 1, popoverProps = null, onClick = utils.noop }) {
  const [isVisible, setIsVisible] = useState(isTouchDevice);

  const handlers = {
    onMouseEnter: () => setIsVisible(true),
    onMouseLeave: () => setIsVisible(false),
  };

  return (
    <div {...(!isTouchDevice && handlers)}>
      <Box
        paddingTop="spacing-xs"
        paddingBottom="spacing-xs"
        paddingLeft="spacing-m"
        paddingRight="spacing-m"
      >
        <HorizontalStack align="space-between">
          <HorizontalStack verticalAlign="center">
            <Paragraph weight="medium">{title}</Paragraph>
            {popoverProps && isVisible && (
              <InfoWithPopover
                {...popoverProps}
                title={popoverProps.title || ''}
                {...(isTouchDevice && { mode: 'popover' })}
              />
            )}
          </HorizontalStack>
          <div role="button" tabIndex={0} style={{ cursor: 'pointer' }} onClick={onClick}>
            <ColorCircle color={color} opacity={opacity} />
          </div>
        </HorizontalStack>
      </Box>
    </div>
  );
}

ColorPanel.propTypes = {
  title: PropTypes.node.isRequired,
  color: PropTypes.string.isRequired,
  opacity: PropTypes.number,
  onClick: PropTypes.func,
  popoverProps: PropTypes.shape({
    title: PropTypes.node,
    content: PropTypes.node,
    imgSrc: PropTypes.string,
  }),
};

export default ColorPanel;
